import { render, staticRenderFns } from "./IbCheckbox.vue?vue&type=template&id=5d5c67d8&scoped=true"
import script from "./IbCheckbox.vue?vue&type=script&lang=js"
export * from "./IbCheckbox.vue?vue&type=script&lang=js"
import style0 from "./IbCheckbox.vue?vue&type=style&index=0&id=5d5c67d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d5c67d8",
  null
  
)

export default component.exports